import { Injectable } from "@angular/core";
import { CoachSort, CoachPrice } from "src/app/common/enums";
import { Pagenation } from "src/app/common/pagenation";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { SessionService } from "../global_services/session.service";

@Injectable({
  providedIn: "root"
})
export class CoachesService {
  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  public GetCourseAllIncluded(id: number) {
    let targetUrl = `${environment.api_base}/public/courses/get?id=${id}`;
    return this.http.get<any>(targetUrl);
  }

  public GetCoaches(
    searchTerm: string = null,
    tags: number[] = null,
    CoachPrice: CoachPrice = null,
    yearsOfExperience: number = null,
    rate: number = null,
    pagenation: Pagenation = null
  ) {
    // build query
    let query = "";
    if (searchTerm) {
      query += `&search=${searchTerm}`;
    }
    if (CoachPrice) {
      query += `&price=${CoachPrice}`;
    }

    if (yearsOfExperience) {
      query += `&years_of_experience=${yearsOfExperience}`;
    }

    if (rate) {
      query += `&rate=${rate}`;
    }

    if (tags && tags.length > 0) {
      query += `&tags=${tags.join(",")}`;
    }

    if (pagenation) {
      if (
        typeof pagenation.rows !== "undefined" &&
        typeof pagenation.page !== "undefined"
      ) {
        query += `&page=${pagenation.page}&page_size=${pagenation.rows}`;
      }
    }

    let targetUrl = `${environment.api_base}/public/coaches/all${query}`;
    return this.http.get<any>(targetUrl);
  }

  public GetCoachesScrollPaging(
    searchTerm: string = null,
    certified: boolean = null,
    SearchTermForSpich: string = null,
    tags: number[] = null,
    CoachPrice: CoachPrice = null,
    yearsOfExperience: number = null,
    rate: number = null,
    pageSize = null,
    pageNumber = null,
    services = null
  ) { 

    let req;

    if (services) {
      req = {
        searchText: searchTerm,
        speciality: SearchTermForSpich,
        rate: rate,
        priceRange: CoachPrice, 
        pageSize: pageNumber,
        pageNumber: pageSize,
        servicesIds: services
      }
    }else {
      req = {
        searchText: searchTerm,
        speciality: SearchTermForSpich,
        rate: rate, 
        priceRange: CoachPrice,
        pageSize: pageNumber,
        pageNumber: pageSize,
      }
    }

    if (certified) { 
      req.certified = certified
    }

    let targetUrl = environment.baseUrl + "CoachRequest/search";

    return this.http.post<any>(targetUrl, req);
  }


  public GetPopularCoaches() {
    let targetUrl = environment.baseUrl + "CoachRequest/search";
    return this.http.post<any>(targetUrl, { pageSize: 3, pageNumber: 1 });
  }

  public GetCalendar() {
    let targetUrl = `${environment.api_base}/private/calendar/get_calendar`;
    return this.http.get<any>(targetUrl);
  }


  public getLanguage() {
    return this.http.post<any>(environment.baseUrl + "Languages/Search", { pageSize: 999, pageNumber: 1 }).toPromise();
  }
  public GetAuthenticatedCoach() {
    let targetUrl = `${environment.baseUrl}CoachRequest/GetActiveRequest`;
    return this.http.get<any>(targetUrl);
  }

  public GetCoach(id) {
    // let targetUrl = `${environment.api_base}/public/coaches/get?id=${id}`;
    let targetUrl = `${environment.baseUrl}CoachRequest/${id}`;
    return this.http.get<any>(targetUrl);
  }

  public GetCoachLight(id) {
    let targetUrl = `${environment.api_base}/public/coaches/get_light?id=${id}`;
    // let targetUrl = `${environment.api_base}CoachRequest/${id}`;
    return this.http.get<any>(targetUrl);
  }

  public UpdateCoach(newCoachFormData) {
    let targetUrl = `${environment.api_base}/private/coaches/update`;
    return this.http.post<any>(targetUrl, newCoachFormData);
  }

  public GetInbox() {
    let targetUrl = `${environment.api_base}/private/coaches/load_messages`;
    return this.http.get<any>(targetUrl);
  }
  
  GetCoachingService = () => this.http.get<any>("https://www.coachyou.io/api/api/CoachingService"); 


  public GetPaymentHistory() {
    let targetUrl = `${environment.api_base}/private/payment/get_transactions`;
    return this.http.get<any>(targetUrl);
  }


  customRequest = (req: FormData) => this.http.post<any>(environment.baseUrl + "AppointmentManagement/create", req);

  getIntersetAreas = () => this.http.get<any>(environment.baseUrl + "InterestArea?CoachingServiceId=1");



  
  
  
}
